const currencyOptions: Intl.NumberFormatOptions = {
  style: "currency",
  currency: "USD",
};
const { format } = new Intl.NumberFormat("en-US", currencyOptions);

export const formatCurrency = (value: number | null | undefined) => (typeof value === "number" ? format(value) : "");
